import {NgModule} from '@angular/core';
import {AnimalOverviewComponent} from "./animal-overview.component";
import {SharedModule} from "../../shared/shared.module";
import {AnimalFiltersComponent} from "./animal-filters/animal-filters.component";
import {DataViewModule} from "primeng/dataview";
import {RatingModule} from "primeng/rating";
import {TagModule} from "primeng/tag";
import {ImageModule} from "primeng/image";
import {InputTextModule} from "primeng/inputtext";
import {DividerModule} from "primeng/divider";
import {AnimalDetailsComponent} from "./animal-details/animal-details.component";
import {TabsModule} from "primeng/tabs";
import {GalleriaModule} from "primeng/galleria";
import {AnimalSexIconComponent} from "./animal-sex-icon/animal-sex-icon.component";
import {AnimalEditDialogComponent} from "./animal-edit-dialog/animal-edit-dialog.component";
import {AnimalCurrentCategoryComponent} from "./animal-current-category/animal-current-category.component";
import {ToggleButtonModule} from "primeng/togglebutton";
import {AnimalAddDialogComponent} from "./animal-add-dialog/animal-add-dialog.component";
import {StepsModule} from "primeng/steps";
import {RadioButtonModule} from "primeng/radiobutton";
import {InputMaskModule} from "primeng/inputmask";
import {FileUploadModule} from "primeng/fileupload";
import {EditorModule} from "primeng/editor";
import {DatePickerModule} from "primeng/datepicker";
import {AnimalDetailsTimelineComponent} from './animal-details-timeline/animal-details-timeline.component';
import {TimelineModule} from 'primeng/timeline';
import {AnimalDetailsWhereaboutsComponent} from './animal-details-whereabouts/animal-details-whereabouts.component';
import {MenuModule} from "primeng/menu";
import {SplitButtonModule} from "primeng/splitbutton";
import {AnimalMoveDialogComponent} from "./animal-move-dialog/animal-move-dialog.component";
import {ContactsModule} from '../contact/contacts.module';
import {AnimalDetailsOriginComponent} from './animal-details-origin/animal-details-origin.component';
import {ChipModule} from "primeng/chip";
import {Message} from "primeng/message";
import {SelectButton} from "primeng/selectbutton";
import {RouterModule} from "@angular/router";
import {AnimalMoveHistoryDialogComponent} from "./animal-move-history-dialog/animal-move-history-dialog.component";
import {AnimalDetailsGalleryComponent} from './animal-details-gallery/animal-details-gallery.component';
import {DatePipe, NgOptimizedImage} from '@angular/common';
import {
  GalleryMultiselectToolbarComponent
} from './animal-details-gallery/toolbar/gallery-multiselect-toolbar.component';
import {GalleryHeaderComponent} from './animal-details-gallery/header/gallery-header.component';
import {GalleryGridComponent} from './animal-details-gallery/grid/gallery-grid.component';
import {EditorFieldComponent} from "../../shared/components/editor-field/editor-field.component";
import {DuplicateAnimalsComponent} from 'src/app/shared/components/duplicate-animals/duplicate-animals.component';
import {
  SendFoundReportDialogComponent
} from 'src/app/shared/components/send-found-report-dialog/send-found-report-dialog.component';
import {
  PickUpReportDialogComponent
} from './animal-details-whereabouts/pick-up-report-dialog/pick-up-report-dialog.component';
import {SentEmailsDialogComponent} from './sent-emails-dialog/sent-emails-dialog.component';
import { AnimalDetailsNotesComponent } from './animal-details-notes/animal-details-notes.component';
import { OriginContactsComponent } from './animal-add-dialog/origin-contacts/origin-contacts.component';
import { SecuredByPoliceComponent } from './animal-add-dialog/secured-by-police/secured-by-police.component';
import { SecuredOriginDetailsComponent } from './animal-details-origin/secured-origin-details/secured-origin-details.component';
import { AnimalDetailsDocumentsComponent } from './animal-details-documents/animal-details-documents.component';
import { DocumentsHeaderComponent } from './animal-details-documents/header/documents-header.component';
import { DocumentsGridComponent } from './animal-details-documents/grid/documents-grid.component';
import { DocumentsMultiselectToolbarComponent } from './animal-details-documents/toolbar/documents-multiselect-toolbar.component';
import { TextareaModule } from 'primeng/textarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressBarModule } from 'primeng/progressbar';
import { AnimalDetailsMedicalComponent } from './animal-details-medical/animal-details-medical.component';
import { MedicalVeterinaryCardComponent } from './animal-details-medical/veterinary-card/medical-veterinary-card.component';
import { MedicalRecordListComponent } from './animal-details-medical/record-list/medical-record-list.component';
import { MedicalRecordDialogComponent } from './animal-details-medical/record-dialog/medical-record-dialog.component';
import { MedicalTreatmentFieldsComponent } from './animal-details-medical/record-dialog/treatment-fields/medical-treatment-fields.component';
import { MedicalFilePreviewComponent } from './animal-details-medical/file-preview/medical-file-preview.component';
import { MedicalProphylaxisComponent } from './animal-details-medical/sections/medical-prophylaxis.component';
import { MedicalConditionsComponent } from './animal-details-medical/sections/medical-conditions.component';
import { MedicalQuarantineComponent } from './animal-details-medical/sections/medical-quarantine.component';
import { MedicalAttachmentsComponent } from './animal-details-medical/sections/medical-attachments.component';
import { FileSizePipe } from './animal-details-medical/file-size.pipe';

@NgModule({
  imports: [
    SharedModule,
    DataViewModule,
    RatingModule,
    TagModule,
    ImageModule,
    InputTextModule,
    DividerModule,
    TabsModule,
    GalleriaModule,
    ToggleButtonModule,
    StepsModule,
    RadioButtonModule,
    InputMaskModule,
    FileUploadModule,
    EditorModule,
    DatePickerModule,
    TimelineModule,
    MenuModule,
    SplitButtonModule,
    ContactsModule,
    ChipModule,
    Message,
    SelectButton,
    RouterModule,
    NgOptimizedImage,
    // Standalone gallery subcomponents
    GalleryMultiselectToolbarComponent,
    GalleryHeaderComponent,
    GalleryGridComponent,
    EditorFieldComponent,
    DuplicateAnimalsComponent,
    SendFoundReportDialogComponent,
    PickUpReportDialogComponent,
    // Standalone documents subcomponents
    DocumentsHeaderComponent,
    DocumentsGridComponent,
    DocumentsMultiselectToolbarComponent,
    TextareaModule,
    InputNumberModule,
    ProgressBarModule
  ],
  declarations: [
    AnimalOverviewComponent,
    AnimalFiltersComponent,
    AnimalDetailsComponent,
    AnimalDetailsOriginComponent,
    AnimalSexIconComponent,
    AnimalAddDialogComponent,
    AnimalEditDialogComponent,
    AnimalCurrentCategoryComponent,
    AnimalDetailsTimelineComponent,
    AnimalDetailsWhereaboutsComponent,
    AnimalMoveDialogComponent,
    AnimalMoveHistoryDialogComponent,
    AnimalDetailsGalleryComponent,
    AnimalDetailsNotesComponent,
    SentEmailsDialogComponent,
    OriginContactsComponent,
    SecuredByPoliceComponent,
    SecuredOriginDetailsComponent,
    AnimalDetailsDocumentsComponent,
    AnimalDetailsMedicalComponent,
    MedicalVeterinaryCardComponent,
    MedicalRecordListComponent,
    MedicalRecordDialogComponent,
    MedicalTreatmentFieldsComponent,
    MedicalFilePreviewComponent,
    MedicalProphylaxisComponent,
    MedicalConditionsComponent,
    MedicalQuarantineComponent,
    MedicalAttachmentsComponent,
    FileSizePipe
  ],
  exports: [
    AnimalAddDialogComponent,
    AnimalCurrentCategoryComponent,
    AnimalSexIconComponent,
  ],
  providers: [
    DatePipe
  ]
})
export class AnimalsModule {
}
